'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Tooltip_Tooltip = require('../Tooltip/Tooltip.cjs.js');
const clsx = require('clsx');
const hooks_useIntersect = require('../../../hooks/useIntersect.cjs.js');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const tooltipWrapper = "_tooltip-wrapper_8x43p_1";
const tooltipWrapperContent = "_tooltip-wrapper-content_8x43p_6";
const positionStyles = "_position-styles_8x43p_39";
const styles = {
	tooltipWrapper: tooltipWrapper,
	tooltipWrapperContent: tooltipWrapperContent,
	positionStyles: positionStyles
};

const correctPosition = (position, result) => {
  const { isTopIntersecting, isBottomIntersecting, isLeftIntersecting, isRightIntersecting } = result;
  if (isBottomIntersecting && position.includes("south")) {
    return position.replace("south", "north");
  } else if (isTopIntersecting && position.includes("north")) {
    return position.replace("north", "south");
  } else if (isLeftIntersecting && position.includes("west")) {
    return position.replace("west", "east");
  } else if (isRightIntersecting && position.includes("east")) {
    return position.replace("east", "west");
  }
  return position;
};
const TooltipWrapper = ({ children, content, allowMultilineTooltip = void 0, isBlock = void 0, position = "south", shouldCorrectPosition = true, showTooltipOnTouchDevices = true, tooltipAriaHidden = true, tooltipId: tooltipIdProp = void 0, zIndex = 10 }) => {
  const [tooltipId] = React.useState(tooltipIdProp || utils_uniqueId.uniqueId("tooltip-"));
  const shouldRenderTooltip = !!content;
  const childProps = {
    "aria-describedby": shouldRenderTooltip ? tooltipId : void 0
  };
  const threshold = 0.9;
  const rootMargin = `-25px`;
  const [setNode, result] = hooks_useIntersect.useIntersect({
    threshold,
    rootMargin
  });
  const correctedPosition = shouldCorrectPosition && result && Object.keys(result).length > 0 ? correctPosition(position, result) : position;
  return React__default.default.createElement(
    "div",
    { className: styles.tooltipWrapper, "data-touch-hidden": !showTooltipOnTouchDevices, "data-block": isBlock, "data-zds": true, ref: setNode },
    children({
      childProps,
      tooltipId
    }),
    shouldRenderTooltip && // Add `ariaHidden to `Tooltip` to prevent it from being accessible
    // and redundantly read by screenreaders.
    React__default.default.createElement(
      "div",
      { className: clsx.clsx(styles.tooltipWrapperContent, styles.positionStyles), "data-testid": `TooltipWrapper__content--${correctedPosition}`, "data-zds": true, "data-position": correctedPosition, style: {
        zIndex
      } },
      React__default.default.createElement(components_display_Tooltip_Tooltip.Tooltip, { allowMultiline: allowMultilineTooltip, "aria-hidden": tooltipAriaHidden, id: tooltipId, position: null }, content)
    )
  );
};

exports.TooltipWrapper = TooltipWrapper;
//# sourceMappingURL=TooltipWrapper.cjs.js.map
